import { number, struct } from 'io-ts/Decoder';

import { Image } from './Image';

export const Type = struct({
	pageNumber: number,
	thumbnail: Image,
	full: Image,
});
